export const manageStyles = (state={}, action) => {
  switch (action.type) {
    case 'SOMETHING_HOVERED':
      return Object.assign(state, { hover: action.payload });
    case 'SET_CURRENT':
      return {};
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/manageStyles.js